import { combineReducers } from "redux";
import user from "../reducers/user/auth"


const combinedReducer = combineReducers({
    user
});

export default combinedReducer;
